module.exports = __webpack_public_path__ + "static/media/nextButton.670fa898.svg";